export default "__VITE_ASSET__Ds3DGdJr__"